import { PricingLimitProfileEndpoints } from '@/modules/seller-management/pricing-limit-profile/api/pricingLimitProfileEndpoints'

/**
 * Pricing Profile endpoint instance
 * instantiate Pricing Profile api class with different api path
 */

export const pricingLimitProfileEndpoints = new PricingLimitProfileEndpoints()
